export var TEXT_TRANSFORM_ENUM;
(function (TEXT_TRANSFORM_ENUM) {
    TEXT_TRANSFORM_ENUM[TEXT_TRANSFORM_ENUM["BOUNDS"] = 0] = "BOUNDS";
    TEXT_TRANSFORM_ENUM[TEXT_TRANSFORM_ENUM["LINE"] = 1] = "LINE";
    TEXT_TRANSFORM_ENUM[TEXT_TRANSFORM_ENUM["WORD"] = 2] = "WORD";
    TEXT_TRANSFORM_ENUM[TEXT_TRANSFORM_ENUM["GLYPH"] = 3] = "GLYPH";
})(TEXT_TRANSFORM_ENUM || (TEXT_TRANSFORM_ENUM = {}));
export var DEFORMER_MANIP_ENUM;
(function (DEFORMER_MANIP_ENUM) {
    DEFORMER_MANIP_ENUM[DEFORMER_MANIP_ENUM["VERTEX"] = 0] = "VERTEX";
    DEFORMER_MANIP_ENUM[DEFORMER_MANIP_ENUM["MATRIX"] = 1] = "MATRIX";
    DEFORMER_MANIP_ENUM[DEFORMER_MANIP_ENUM["UV"] = 2] = "UV";
    DEFORMER_MANIP_ENUM[DEFORMER_MANIP_ENUM["COLOR"] = 4] = "COLOR";
})(DEFORMER_MANIP_ENUM || (DEFORMER_MANIP_ENUM = {}));
export var TRANSFORM_DIRECTION;
(function (TRANSFORM_DIRECTION) {
    TRANSFORM_DIRECTION[TRANSFORM_DIRECTION["LEFT_TO_RIGHT"] = 0] = "LEFT_TO_RIGHT";
    TRANSFORM_DIRECTION[TRANSFORM_DIRECTION["RIGHT_TO_LEFT"] = 1] = "RIGHT_TO_LEFT";
    TRANSFORM_DIRECTION[TRANSFORM_DIRECTION["TOP_TO_BOTTOM"] = 2] = "TOP_TO_BOTTOM";
    TRANSFORM_DIRECTION[TRANSFORM_DIRECTION["BOTTOM_TO_TOP"] = 3] = "BOTTOM_TO_TOP";
})(TRANSFORM_DIRECTION || (TRANSFORM_DIRECTION = {}));
